import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-3 text-body-2" }
const _hoisted_2 = { class: "ma-0 pl-4 text-body-2" }
const _hoisted_3 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_4 = { class: "text-body-2 mb-1" }
const _hoisted_5 = {
  key: 0,
  class: "text-red"
}
const _hoisted_6 = { class: "text-white text-caption" }
const _hoisted_7 = {
  key: 0,
  class: "mt-3 text-body-2 text-success"
}
const _hoisted_8 = {
  key: 1,
  class: "mt-3 text-body-2 text-red"
}
const _hoisted_9 = {
  class: "d-flex mt-5",
  style: {"gap":"0.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "540",
    persistent: "",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-5" }, {
        default: _withCtx(() => [
          _createVNode(_component_page_title, {
            value: _ctx.$t('aiReport.bulkGenerateTitle')
          }, null, 8, ["value"]),
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('aiReport.targetQuarter', {
            months: _ctx.monthsLabel,
            year: _ctx.businessYear,
            quarter: _ctx.quarter,
          })), 1),
          _createVNode(_component_v_alert, {
            variant: "outlined",
            color: "primary",
            icon: "mdi-information-outline",
            class: "mt-2",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_2, [
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('aiReport.bulkHints.newReports')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('aiReport.bulkHints.overwriteDrafts')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('aiReport.bulkHints.skipPublished')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('aiReport.bulkHints.async')), 1)
              ])
            ]),
            _: 1
          }),
          (_ctx.batch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$t('aiReport.generatingProgress', {
              success: _ctx.batch.successCount,
              total: _ctx.batch.totalCount,
            })) + " ", 1),
                  (_ctx.batch.failedCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('aiReport.failedCount', { count: _ctx.batch.failedCount })), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_v_progress_linear, {
                  "model-value": _ctx.progressPercent,
                  indeterminate: _ctx.batch.status === 'processing' && _ctx.batch.successCount === 0,
                  color: "primary",
                  height: "14",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.progressPercent) + "%", 1)
                  ]),
                  _: 1
                }, 8, ["model-value", "indeterminate"]),
                (_ctx.batch.status === 'completed')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        color: "success"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-check-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.generationCompleted')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.batch.status === 'failed')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        color: "red"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-alert-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.generationFailed')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              variant: "text",
              onClick: _ctx.close,
              disabled: _ctx.isStarting
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.batch && _ctx.batch.status === 'completed'
              ? _ctx.$t('common.close')
              : _ctx.$t('common.cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            (!_ctx.batch)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  color: "primary",
                  variant: "flat",
                  loading: _ctx.isStarting,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('start')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('aiReport.bulkGenerateStart')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}